import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  GetDocumentsDocTypeEnum,
  GetSurveySurveyCodeEnum,
  SessionInfoResponse,
  SessionPublicAPIsForStartFlowApi,
  SessionStateEnum,
} from "../../orchestrator-api-client";
import { ThunkApi } from "../store.ts";
import { getConfig } from "./get-config.action.ts";
import { getOffers } from "./get-offers.action.ts";
import { getCoherenceQuestionnaireData } from "./get-coherence-questionnaire-data.action.ts";
import { getAdvQuestionnaires } from "./get-adv-questionnaires.action.ts";
import { getDocumentsList } from "./get-documents-list.action.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

const initStore = createAsyncThunk<
  SessionInfoResponse | undefined,
  { workflowId: string | undefined; isExternalChannel?: boolean },
  ThunkApi
>(
  "initStore",
  async (
    { workflowId, isExternalChannel = false },
    { dispatch, rejectWithValue },
  ) => {
    if (workflowId || isExternalChannel) {
      try {
        const { data } =
          await new SessionPublicAPIsForStartFlowApi().getAccount();
        const fiscalCode = data.customer?.personalInfo?.fiscalCode;
        switch (data.session?.state) {
          case SessionStateEnum.Cpi:
          case SessionStateEnum.Offer:
            await dispatch(getConfig());
            await dispatch(getOffers());
            break;
          case SessionStateEnum.Adv:
            await dispatch(getConfig());
            await dispatch(getOffers());
            await dispatch(
              getAdvQuestionnaires({
                surveyCode: GetSurveySurveyCodeEnum.Adeguataverifica,
                fiscalCode,
              }),
            );
            break;
          case SessionStateEnum.CpiQuestionnaire:
            await dispatch(getConfig());
            await dispatch(getOffers());
            await dispatch(
              getCoherenceQuestionnaireData({
                surveyCode: GetSurveySurveyCodeEnum.AdegAssic,
                fiscalCode,
              }),
            );
            break;
          case SessionStateEnum.Payroll:
            await dispatch(getDocumentsList(GetDocumentsDocTypeEnum.Payrolls));
            break;
          case SessionStateEnum.AccountStatement:
            await dispatch(
              getDocumentsList(GetDocumentsDocTypeEnum.AccountStatement),
            );
            break;
        }
        return data;
      } catch (err: any) {
        pushErrorMonitor(err); //send error push monitor
        const error: LayoutError = {
          title: "Recupero sessione",
          description:
            "Non siamo riusciti a recuperare la sessione.\n Puoi riprovare o contattare il supporto",
          error: err.message,
        };
        return rejectWithValue(error);
      }
    }
  },
);
export default initStore;
